<template>
  <div class="info-section">
    <h4 class="gm-label">Basic Information</h4>
    <div class="info-grid">
      <div class="info-item info-item--wide">
        <label class="gm-label">Room ID</label>
        <span class="info-id">{{ room.id }}</span>
      </div>
      <div class="info-item">
        <label class="gm-label">Position</label>
        <span class="info-coords">{{ room.position.grid_x }}, {{ room.position.grid_y }}, {{ room.position.grid_z }}</span>
      </div>
      <div class="info-item">
        <label class="gm-label" for="room-type">Type</label>
        <select id="room-type" class="gm-select" v-model="localRoomType" :disabled="!editable" @change="onTypeChange">
          <option value="default">Default</option>
          <option value="special">Special</option>
          <option value="secret">Secret</option>
          <option value="dangerous">Dangerous</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicInformation',
  props: {
    room: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localRoomType: this.room.type || 'default'
    };
  },
  watch: {
    'room.type': {
      handler(newType) {
        this.localRoomType = newType || 'default';
      },
      immediate: true
    }
  },
  methods: {
    onTypeChange() {
      this.$emit('update:room-type', this.localRoomType);
    }
  }
};
</script>

<style scoped>
.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--gm-gap-sm) var(--gm-gap);
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

/* A UUID has no natural break point; on its own row it wraps once instead of
   dragging the whole grid out of alignment. */
.info-item--wide {
  grid-column: 1 / -1;
}

.info-item span {
  font-size: var(--gm-text-xs);
  line-height: var(--gm-leading-tight);
  color: var(--gm-text);
}

.info-id,
.info-coords {
  font-family: var(--gm-font-mono);
  font-size: var(--gm-text-micro) !important;
  color: var(--gm-text-muted) !important;
  overflow-wrap: anywhere;
}

.info-coords {
  font-variant-numeric: tabular-nums;
}

.info-item select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
